<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/Page-header";
import ScoreTableModal from "@/components/ScoreTableModal";

/**
 * Starter component
 */
export default {
  head () {
    return {
      title: `${this.title} | Minton - Nuxtjs Responsive Admin Dashboard Template`,
    };
  },
  data () {
    return {
      title: "用戶使用紀錄",
      items: [
        {
          text: "法語鸚鵡螺",
          href: "/",
        },
        {
          text: "用戶使用紀錄",
          active: true,
        }
      ],
      pluginItem: {
        title: '',
        des: ''
      },
      searchMonth: null,
      memberId: false,
      memberData: {},
      records: [],
      playing: false,
      historySecondByMonth: 0,
      currentPage: 1,
      totalRows: 1,
      perPgae: 15,
      selectedRecord: null,
    };
  },
  components: {
    Layout,
    PageHeader,
    ScoreTableModal,
  },
  created () {
    this.memberId = this.$route.params.itemId
    this.getMemberRecordList()
    this.getMemberInformatDetail()
  },
  watch: {
    currentPage (_page) {
      this.getMemberRecordList()
    }
  },
  methods: {
    getMemberInformatDetail () {
      let vm = this
      this.$root.apis.getMemberInformation(this.memberId, function (_response) {
        vm.memberData = _response.body.data
        vm.historySecondByMonth = vm.memberData.secondByMonth
      })
    },
    getMemberRecordList () {
      let searchData = {
        member_id: this.memberId,
        page: this.currentPage
      }
      this.$root.apis.getMemberRecordDetail(searchData, this.processGetMemberRecordSuccess)
    },
    searchMonthUseSeconds () {
      console.log('--> 調閱月份使用秒數:', this.searchMonth);
      let vm = this
      this.$root.apis.getMemberUseSecondByMonth(this.memberId, this.searchMonth, function (_response) {
        vm.historySecondByMonth = _response.body.seconds
      })
    },
    processGetMemberRecordSuccess (_response) {
      this.records = _response.body.items
      // 處理分頁相關
      this.currentPage = _response.body.page
      this.totalRows = _response.body.total
      this.perPgae = _response.body.per_page
    },
    createTopic () {

    },
    editorTopic () {

    },
    playAudio (url, onEndedCallback = null) {
      console.log("播放指定檔案:", url);
      const audio = new Audio(url);

      // 播放結束事件
      if (typeof onEndedCallback === 'function') {
        audio.addEventListener('ended', onEndedCallback);
      }

      this.playing = true

      audio.play().catch(error => {
        console.error("無法播放音訊：", error);
      });
    },
    playStop () {
      this.playing = false
    },
    showScoreModal (record) {
      this.selectedRecord = record
      this.$bvModal.show('score-table-modal')
    },
    exportHistoryRecords () {
      let vm = this
      this.$root.apis.exportMemberHistoryRecords(this.memberId, function (response) {
        // 創建下載連結
        const url = window.URL.createObjectURL(new Blob([response.body], { type: 'text/csv;charset=utf-8' }))
        const link = document.createElement('a')
        link.href = url

        // 從響應頭獲取文件名，如果沒有則使用默認名稱
        const contentDisposition = response.headers.get('content-disposition')
        let filename = 'user_history_export.csv'
        if (contentDisposition) {
          const filenameMatch = contentDisposition.match(/filename="(.+)"/)
          if (filenameMatch) {
            filename = filenameMatch[1]
          }
        } else {
          // 如果沒有從響應頭獲取到文件名，使用時間戳和用戶郵箱生成文件名
          const now = new Date()
          const timestamp = now.getFullYear().toString() +
            (now.getMonth() + 1).toString().padStart(2, '0') +
            now.getDate().toString().padStart(2, '0') +
            now.getHours().toString().padStart(2, '0') +
            now.getMinutes().toString().padStart(2, '0')
          filename = timestamp + '_' + vm.memberData.email + '.csv'
        }

        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)

        // 顯示成功訊息
        vm.$bvToast.toast('歷史紀錄已成功下載', {
          title: '下載完成',
          variant: 'success',
          solid: true
        })
      }, function (error) {
        console.error('導出失敗:', error)
        vm.$bvToast.toast('導出失敗，請稍後再試', {
          title: '錯誤',
          variant: 'danger',
          solid: true
        })
      })
    },
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-md-4 col-sm-12">
        <b-card>
          <div class="row">
            <div class="col-12">
              <div class="text-area">用戶: {{ memberData.email }}</div>
              <div class="text-area">方案: {{ memberData.planMin }}分鐘/月</div>
              <b-button class="mt-2" size="sm" variant="primary" @click="exportHistoryRecords">歷史紀錄輸出</b-button>
            </div>
          </div>
        </b-card>
      </div>
      <div class="col-md-4 col-sm-12">
        <b-card>
          <div class="row">
            <div class="col-12">
              <div class="text-area mb-1">當月總錄音時間： {{ $root.common.getTimeHourAndMin(memberData.secondByMonth) }}</div>
              <div class="text-area mb-1">總錄音時間： {{ $root.common.getTimeHourAndMin(memberData.secondByTotal) }}</div>
              <div class="text-area mb-1">總平均分數： {{ memberData.scoreByTotal }} / 100</div>
            </div>
          </div>
        </b-card>
      </div>
      <div class="col-md-4 col-sm-12">
        <b-card>
          <div class="row">
            <div class="col-12">
              <div class="text-area mb-1">歷史月份總錄音時間： {{ $root.common.getTimeHourAndMin(historySecondByMonth)
              }}
              </div>
              <b-form-group id="example-month" label-cols-sm="2" label-cols-lg="2" label="Month" label-for="month">
                <b-form-input id="month" value="2025-05" type="month" v-model="searchMonth"
                  @change="searchMonthUseSeconds"></b-form-input>
              </b-form-group>
            </div>
          </div>
        </b-card>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-borderless mb-0">
                <thead class="thead-light">
                  <tr class="text-center">
                    <th>項次</th>
                    <th>模組名稱</th>
                    <th>題目類型</th>
                    <th>題目名稱</th>
                    <th>測試時間</th>
                    <th>錄音時間</th>
                    <th>用戶聲音</th>
                    <th>評分</th>
                    <th>結果</th>
                  </tr>
                </thead>
                <tbody v-if="!records.length">
                  <tr>
                    <td colspan="9" class="text-center">無資料</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr v-for="(record, index) in records">
                    <td class="text-center">{{ index + 1 }}</td>
                    <td class="text-left">{{ record.themeName }}</td>
                    <td class="text-center">
                      <span class="badge badge-soft-success" v-if="record.topicType == 1">單詞</span>
                      <span class="badge badge-soft-success badge-soft-warning" v-if="record.topicType == 2">句子</span>
                    </td>
                    <td class="text-left">{{ record.topicName }}</td>
                    <td class="text-center">{{ record.testAt }}</td>
                    <td class="text-center">{{ $root.common.getTimeHourAndMin(record.seconds) }}</td>
                    <td class="text-center">
                      <b-button v-if="!playing" size="sm" variant="success"
                        @click="playAudio($root.mediaUri + record.voice, playStop)">
                        <i class="fe-play"></i>
                      </b-button>
                      <b-spinner v-else small variant="secondary" role="status"></b-spinner>
                    </td>
                    <td class="text-center">{{ record.total_score }} / 100</td>
                    <td class="text-center">
                      <b-button v-if="record.rawData && record.rawData.text_score" size="sm" variant="info"
                        @click="showScoreModal(record)">
                        查看詳情
                      </b-button>
                      <span v-else class="text-muted">無數據</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>

    <div class="row">
      <div class="col">
        <div class="dataTables_paginate paging_simple_numbers float-right">
          <ul class="pagination pagination-rounded">
            <!-- pagination -->
            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPgae"></b-pagination>
          </ul>
        </div>
      </div>
    </div>

    <!-- 評分表格彈窗 -->
    <ScoreTableModal modal-id="score-table-modal"
      :modal-title="`${selectedRecord ? selectedRecord.topicName : ''} - 評分詳情`"
      :score-data="selectedRecord ? selectedRecord.rawData : null" />

  </Layout>
</template>
